export type DocumentsCO = {
  committee?: {
    ctl?: string[];
    deed?: string[];
    admin_receipt?: string[];
    garage_ctl?: string[];
    deposit_ctl?: string[];
    bank_statement?: string[];
    additional_documents?: string[];
  };
};

export const mapDocumentsCO = (data: DocumentsCO) => {
  const mappings = {
    committee: {
      ctl: 'Documento CTL',
      deed: 'Documento Escritura',
      admin_receipt: 'Recibo administración',
      garage_ctl: 'Garaje CTL',
      deposit_ctl: 'Depósito CTL',
      bank_statement: 'Extracto bancario',
      additional_documents: 'Docs adicionales',
    },
  } as const;

  const documents: { id: string; title: string; fileUrl: string }[] = [];

  for (const key of Object.keys(mappings) as Array<keyof typeof mappings>) {
    const subMappings = mappings[key];

    for (const subKey of Object.keys(subMappings) as Array<
      keyof typeof subMappings
    >) {
      const fileUrls = data?.[key]?.[subKey];

      if (Array.isArray(fileUrls) && fileUrls.length > 0) {
        const showSuffix = fileUrls.length > 1;

        fileUrls.forEach((fileUrl, index) => {
          if (fileUrl) {
            documents.push({
              id: `${key}_${subKey}_${index}`,
              title: showSuffix
                ? `${subMappings[subKey]} (${index + 1})`
                : subMappings[subKey],
              fileUrl,
            });
          }
        });
      }
    }
  }

  return documents;
};
